module.exports = __webpack_public_path__ + "img/ic_time.930b8cf9.svg";